import { MedicalNoteActivity, MedicalNoteType } from '@uplift/api';
import { CommunicationNoteActivityItem } from './CommunicationNoteItem.component';
import { DischargeNoteActivityItem } from './DischargeNoteActivityItem.component';
import { User } from '@uplift/types';
import { ClaimCorrectionNoteActivityItem } from './ClaimCorrectionNoteActivityItem.component';

export type BaseNoteActivityItemProps = {
  noteType: MedicalNoteType;
  note: MedicalNoteActivity;
  provider: User;
  onClick?: () => void;
};

export const BaseNoteActivityItem: React.FC<BaseNoteActivityItemProps> = props => {
  switch (props.noteType) {
    case MedicalNoteType.communicationNote:
      return <CommunicationNoteActivityItem {...props} />;
    case MedicalNoteType.therapyDischargeNote:
    case MedicalNoteType.psychiatryDischargeNote:
      return <DischargeNoteActivityItem {...props} />;
    case MedicalNoteType.claimCorrectionNote:
      return <ClaimCorrectionNoteActivityItem {...props} />;
    default:
      return <div>Note-thing to see here</div>;
  }
};
